import i18next from "i18next";
import { CreateView, IndexView, withBreadCrumbs } from "lego-gui-lib/lib";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  Route,
  RouteComponentProps,
  Switch,
  useHistory,
  useRouteMatch
} from "react-router";
import { CustomerAwareRowButtons } from "../../common/CustomerAwareRowButtons";
import { authStoreContext } from "../../core/mainStore";
import { authSchemaHelper } from "../../core/model/authSchemaHelper";
import { ParentRoute } from "../../core/model/parent";
import { ShowCalendar } from "./calendarView/ShowCalendarComponent";
import {
  CalendarColumns,
  calendarContext,
  CreateCalendarSchema,
  customerCalendarContext
} from "./schema";

export const Calendar = {
  url: "/calendars",
  handler: (props: RouteComponentProps<any>) => {
    const baseUrl = props.match.url;
    const title = i18next.t("hns:calendar:domain_plural");
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <ParentRoute path={baseUrl + "/:id"} dataSourceName={"calendar"} />
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Create} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={ShowCalendar} />
        </Switch>
      </>
    );
  }
};

export const Index = observer(({ ...rest }: any) => {
  const calendar = useContext(calendarContext);
  const customerCalendar = useContext(customerCalendarContext);

  const auth = useContext(authStoreContext);

  const { i18n } = useTranslation();
  const title = i18n.t("hns:calendar:domain", { count: 2 });

  return (
    <IndexView
      dataSource={
        auth.isAnyCustomerOwner() ? customerCalendar : calendar.listDataSource
      }
      {...rest}
      title={title}
      toolbarButtons={{ delete: true, export: true }}
      rowButtons={CustomerAwareRowButtons}
      columns={CalendarColumns}
    />
  );
});

export const Create = observer(({ ...rest }: any) => {
  const calendar = useContext(calendarContext);
  const match = useRouteMatch();
  const history = useHistory();

  const { i18n } = useTranslation();
  const title = i18n.t("common:create", { domain: "hns:calendar:domain" });

  return withBreadCrumbs(
    { to: match.url + "/edit", children: title },
    <CreateView
      dataSource={calendar.oneDataSource}
      {...rest}
      title={title}
      initialValues={authSchemaHelper.prepareInitialValuesForAnyCustomerOwnerCreate(
        calendar,
        { charged: 1 }
      )}
      fields={CreateCalendarSchema}
      id={match.params}
      goBack={() => history.goBack()}
    />
  );
});
